var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 926,
    viewBox: "0 0 370 926",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M885.384 976.346H2.4375M2.4375 976.346L885.384 0.633728M2.4375 976.346L885.384 98.6579M2.4375 976.346L885.384 184.968M2.4375 976.346L885.384 264.637M2.4375 976.346L885.384 337.807M2.4375 976.346L885.384 405.609M2.4375 976.346L885.384 468.948M2.4375 976.346L885.384 528.564M2.4375 976.346L885.384 585.077M2.4375 976.346L885.384 639.01M2.4375 976.346L885.384 690.972M2.4375 976.346L885.384 740.877M2.4375 976.346L885.384 790.324M2.4375 976.346L885.384 837.17M2.4375 976.346L885.384 883.33M2.4375 976.346L885.384 930.295",
    stroke: "#0E5C57",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector (1).1834cdb0bfc7a9260edf165df94164ba.svg";
export { ForwardRef as ReactComponent };